import { ReactNode } from 'react';
import { useLiveInsightsWebSocket } from '../hooks/useLiveInsightsWebSocket';
import { LiveInsightsContext } from './LiveInsightsContextShared';

export function LiveInsightsProvider({ sessionId, children }: { sessionId: string; children: ReactNode }) {
    const ws = useLiveInsightsWebSocket(sessionId);

    return (
        <LiveInsightsContext.Provider value={ws}>
            {children}
        </LiveInsightsContext.Provider>
    );
}
